var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 5C13.125 5.8288 12.7958 6.62366 12.2097 7.20971C11.6237 7.79576 10.8288 8.125 10 8.125C9.17122 8.125 8.37636 7.79576 7.79031 7.20971C7.20426 6.62366 6.87502 5.8288 6.87502 5C6.87502 4.1712 7.20426 3.37634 7.79031 2.79029C8.37636 2.20424 9.17122 1.875 10 1.875C10.8288 1.875 11.6237 2.20424 12.2097 2.79029C12.7958 3.37634 13.125 4.1712 13.125 5ZM3.75085 16.765C3.77763 15.1253 4.4478 13.5618 5.61684 12.4117C6.78587 11.2616 8.36009 10.6171 10 10.6171C11.6399 10.6171 13.2142 11.2616 14.3832 12.4117C15.5522 13.5618 16.2224 15.1253 16.2492 16.765C14.2887 17.664 12.1568 18.1279 10 18.125C7.77002 18.125 5.65335 17.6383 3.75085 16.765Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarProfile);
export default __webpack_public_path__ + "static/media/sidebar-profile.1e0eddc63a959f52aadb66af9457e1e9.svg";
export { ForwardRef as ReactComponent };